export default {"src":"/_next/static/media/comments_bold.41a026ea.svg","height":24,"width":24};